import {useState} from "react";
import {css, cx} from "@panda/css";

import {Loader} from "@pg-design/loader-module";
import {useElementWasVisible} from "@pg-mono/hooks";

import {OfferType} from "../../types/OfferType";
import {offerOpinionLS} from "../../utils/offer_opinion_cookies";
import {OfferDetailOpinionsForm} from "./OfferDetailOpinionsForm";
import {OfferDetailOpinionsSuccess} from "./OfferDetailOpinionsSuccess";

interface Props {
    offer: {
        type: OfferType;
        id: number;
    };
    property?: {
        id: number;
    };
}

const pollElementId = "poll_user_interest";

export const OfferDetailOpinions = (props: Props) => {
    const [opinionsState, setOpinionsState] = useState<"loader" | "form" | "success">("loader");

    const onElementVisible = () => {
        const isOpinionSent = offerOpinionLS.getIsOpinionSent(props.offer.id);
        if (isOpinionSent) {
            setOpinionsState("success");
            return;
        }

        setOpinionsState("form");
    };

    useElementWasVisible({
        ids: [pollElementId],
        onElementVisible,
        threshold: 0.1,
        once: true
    });

    switch (opinionsState) {
        case "form":
            return (
                <div className={outerWrapper}>
                    <OfferDetailOpinionsForm offer={props.offer} property={props.property} onSubmit={() => setOpinionsState("success")} />
                </div>
            );
        case "success":
            return (
                <div className={cx(outerWrapper, successStyle)}>
                    <OfferDetailOpinionsSuccess />
                </div>
            );
        case "loader":
            return (
                <div data-id={pollElementId} className={outerWrapper}>
                    <Loader className={opinionsPollLoaderStyle} />
                </div>
            );
    }
};

const OPINIONS_CONTAINER_NAME = "opinions_container";

const outerWrapper = css({
    borderRadius: 2,
    pt: 3,
    pb: 4,
    px: 3,
    backgroundColor: "var(--colors-white)",
    containerType: "inline-size",
    containerName: `${OPINIONS_CONTAINER_NAME}`
});

const successStyle = css({
    backgroundColor: "var(--colors-success)"
});

const opinionsPollLoaderStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    // minimize layout shifts by setting variable loader height
    height: "280px",
    "@container opinions_container (min-width: 700px)": {
        height: "264px"
    }
});
import {useState} from "react";
import {css, cx} from "@panda/css";

import {Loader} from "@pg-design/loader-module";
import {useElementWasVisible} from "@pg-mono/hooks";

import {OfferType} from "../../types/OfferType";
import {offerOpinionLS} from "../../utils/offer_opinion_cookies";
import {OfferDetailOpinionsForm} from "./OfferDetailOpinionsForm";
import {OfferDetailOpinionsSuccess} from "./OfferDetailOpinionsSuccess";

interface Props {
    offer: {
        type: OfferType;
        id: number;
    };
    property?: {
        id: number;
    };
}

const pollElementId = "poll_user_interest";

export const OfferDetailOpinions = (props: Props) => {
    const [opinionsState, setOpinionsState] = useState<"loader" | "form" | "success">("loader");

    const onElementVisible = () => {
        const isOpinionSent = offerOpinionLS.getIsOpinionSent(props.offer.id);
        if (isOpinionSent) {
            setOpinionsState("success");
            return;
        }

        setOpinionsState("form");
    };

    useElementWasVisible({
        ids: [pollElementId],
        onElementVisible,
        threshold: 0.1,
        once: true
    });

    switch (opinionsState) {
        case "form":
            return (
                <div className={outerWrapper}>
                    <OfferDetailOpinionsForm offer={props.offer} property={props.property} onSubmit={() => setOpinionsState("success")} />
                </div>
            );
        case "success":
            return (
                <div className={cx(outerWrapper, successStyle)}>
                    <OfferDetailOpinionsSuccess />
                </div>
            );
        case "loader":
            return (
                <div data-id={pollElementId} className={outerWrapper}>
                    <Loader className={opinionsPollLoaderStyle} />
                </div>
            );
    }
};

const OPINIONS_CONTAINER_NAME = "opinions_container";

const outerWrapper = css({
    borderRadius: 2,
    pt: 3,
    pb: 4,
    px: 3,
    backgroundColor: "var(--colors-white)",
    containerType: "inline-size",
    containerName: `${OPINIONS_CONTAINER_NAME}`
});

const successStyle = css({
    backgroundColor: "var(--colors-success)"
});

const opinionsPollLoaderStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    // minimize layout shifts by setting variable loader height
    height: "280px",
    "@container opinions_container (min-width: 700px)": {
        height: "264px"
    }
});
